module.exports = __webpack_public_path__ + "img/fal-id-badge.baaa7443.svg";